import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'title',
      type: 'input',
      label: '标题',
      filterable: true,
      placeholder: '请输入标题',
      rules: { required: true, message: '标题是必填的', trigger: 'blur' }
    },
    {
      field: 'sort',
      type: 'number',
      label: '列表排序',
      styles:{width:'250px'},
      rules: { required: true, message: '请输入排序值 0-100 之间', trigger: 'blur' }
    },
    // {
    //   field: 'contents',
    //   type: 'customSlot',
    //   label: '',
    //   labelWidth:'10px',
    //   filterable: true,
    // },
  ],
  colLayout: 24,
  itemStyle: {}
}
